export const getTwoLettersInitials = (firstName: string, lastName: string) => {
  const fullName = `${(firstName || '').trim()} ${(lastName || '').trim()}`.toUpperCase()
  const nameParts = fullName.split(' ').filter((part) => part.trim() !== '')
  if (nameParts.length >= 2) {
    return nameParts[0][0] + nameParts[nameParts.length - 1][0]
  }
  return fullName.slice(0, 2)
}
